<template>
  <button
    v-if="showScrollUp"
    type="button"
    class="order-btn order-btn_scroll-up"
    aria-label="Вверх"
    @click="scrollToTop"
  >
    <span class="order-btn__icon" aria-hidden="true">↑</span>
  </button>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'OrderButton',
  setup() {
    const showScrollUp = ref(false)

    function onScroll() {
      showScrollUp.value = window.scrollY > 200
    }

    function scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    onMounted(() => {
      window.addEventListener('scroll', onScroll, { passive: true })
      onScroll()
    })
    onUnmounted(() => {
      window.removeEventListener('scroll', onScroll)
    })

    return { showScrollUp, scrollToTop }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.order-btn {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 90;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: $order-btn-size;
  min-height: $order-btn-size;
  padding: 0 20px;
  background: $order-btn-bg;
  color: $order-btn-text;
  font-weight: 600;
  font-size: 15px;
  border: none;
  text-decoration: none;
  border-radius: 50px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s, box-shadow 0.2s, background 0.2s;
  cursor: pointer;

  &:hover {
    background: $color-accent-teal;
    transform: scale(1.05);
    box-shadow: 0 6px 24px rgba(13, 148, 136, 0.4);
  }

  &_scroll-up:hover {
    background: $order-btn-bg;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.3);
  }

  &_scroll-up {
    padding: 0;
    border-radius: 50%;
  }

  &__icon {
    font-size: 20px;
    line-height: 1;
  }

  @media (max-width: $breakpoint-mobile) {
    right: 16px;
    bottom: 16px;
    min-width: 48px;
    min-height: 48px;
    padding: 0 16px;
    font-size: 14px;

    &_scroll-up {
      padding: 0 16px;
    }
  }
}
</style>
